/* R&B stores: open / closed right now, worked out in each store's own time zone (hours are entered in local time). */
(function () {
  var el = document.getElementById('RbStoresData');
  if (!el) return;
  var data;
  try { data = JSON.parse(el.textContent); } catch (e) { return; }
  var t = data.t;

  function parseRange(s) {
    if (!s) return null;
    var m = String(s).match(/(\d{1,2})[:.]?(\d{2})?\s*[-–—]\s*(\d{1,2})[:.]?(\d{2})?/);
    if (!m) return null;
    return [ +m[1] + (+(m[2] || 0)) / 60, +m[3] + (+(m[4] || 0)) / 60 ];
  }
  function fmt(x) {
    var h = Math.floor(x), mi = Math.round((x - h) * 60);
    if (data.h12) { var h12 = h % 12 || 12; return h12 + (mi ? ':' + (mi < 10 ? '0' : '') + mi : '') + (h < 12 ? ' AM' : ' PM'); }
    return (h < 10 ? '0' : '') + h + ':' + (mi < 10 ? '0' : '') + mi;
  }
  function nowIn(tz) {
    var p = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { date: p.year + '-' + p.month + '-' + p.day, wd: ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'].indexOf(p.weekday), t: (+p.hour % 24) + (+p.minute) / 60 };
  }
  function addDays(iso, n) { var d = new Date(iso + 'T12:00:00Z'); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); }
  function exceptions(st) {
    var map = {};
    String(st.exceptions || '').split(/\n/).forEach(function (line) {
      var m = line.match(/(\d{4}-\d{2}-\d{2})\s*:?\s*(.*)$/);
      if (m) map[m[1]] = parseRange(m[2]); /* "closed" → null */
    });
    return map;
  }
  function hoursOn(st, ex, iso, wd) { return Object.prototype.hasOwnProperty.call(ex, iso) ? ex[iso] : parseRange(st.hours[wd]); }
  function status(st) {
    if (st.status === 'soon') return { cls: 'is-soon', long: st.soon || '', short: st.soon || '' };
    var n = nowIn(st.tz), ex = exceptions(st);
    var today = hoursOn(st, ex, n.date, n.wd);
    if (today && n.t >= today[0] && n.t < today[1]) return { cls: 'is-open', long: t.open.replace('{t}', fmt(today[1])), short: t.openShort };
    if (today && n.t < today[0]) return { cls: 'is-closed', long: t.today.replace('{t}', fmt(today[0])), short: t.closedShort };
    for (var k = 1; k <= 14; k++) {
      var iso = addDays(n.date, k), wd = (n.wd + k) % 7, h = hoursOn(st, ex, iso, wd);
      if (h) return { cls: 'is-closed', long: (k === 1 ? t.tomorrow : t.later.replace('{d}', t.days[wd])).replace('{t}', fmt(h[0])), short: t.closedShort };
    }
    return { cls: 'is-closed', long: t.closed, short: t.closedShort };
  }
  function paint() {
    data.stores.forEach(function (st) {
      if (st.status === 'hidden') return;
      var s = status(st);
      document.querySelectorAll('[data-rb-store-status="' + st.i + '"]').forEach(function (node) {
        node.classList.remove('is-open', 'is-closed', 'is-soon');
        node.classList.add(s.cls);
        var label = node.querySelector('[data-rb-store-label]') || node;
        label.textContent = node.hasAttribute('data-short') ? s.short : s.long;
      });
    });
  }
  /* Client Care sidebar: chat / phone availability follows store 1 (Stockholm) hours; the button reads
     "Start live chat" when someone is there and "Leave us a message" when not. */
  function paintChat() {
    var st = data.stores[0];
    if (!st || st.status === 'hidden') return;
    var s = status(st), open = s.cls === 'is-open';
    var tz = t.tz || '';
    document.querySelectorAll('[data-rb-chat-status]').forEach(function (node) {
      node.classList.remove('is-open', 'is-closed');
      node.classList.add(open ? 'is-open' : 'is-closed');
      var label = node.querySelector('[data-rb-store-label]') || node;
      label.textContent = (open ? s.long.replace(t.open.split('{t}')[0], t.chatOpen.split('{t}')[0]) : s.long) + tz;
    });
    document.querySelectorAll('[data-rb-chat-button]').forEach(function (b) {
      b.textContent = open ? b.getAttribute('data-open-label') : b.getAttribute('data-closed-label');
      b.classList.toggle('is-closed', !open); // closed: a quieter outline button, still usable (it opens the message form)
    });
  }
  var paintAll = function () { paint(); paintChat(); };
  paintAll();
  setInterval(paintAll, 60000);
  document.addEventListener('shopify:section:load', paintAll);
  window.RbStores = { paint: paintAll };
})();
